// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + chunkId + "." + "94b3d3d6f90192ada1ac" + ".js";
};